import React, { useState } from 'react'
import { Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { Modal } from 'src/components/Ant'
import { Request } from 'src/types'

interface Props
  extends Readonly<{
    setVisible: React.Dispatch<React.SetStateAction<boolean>>
    saveRequest: (request: Request) => void
    visible: boolean
    request: Request
  }> {}

export function ModalRequestSummaryObservation({
  request,
  saveRequest,
  setVisible,
  visible
}: Props) {
  const [value, setValue] = useState(request.obs)

  const { t } = useTranslation()
  return (
    <Modal
      closable
      onCancel={() => setVisible(false)}
      onOk={async () => {
        await saveRequest({ ...request, obs: value.trim() })
        setVisible(false)
      }}
      title="web.assignment.billing.form.observation.title"
      visible={visible}
    >
      <Input.TextArea
        allowClear
        onChange={e => setValue(e.target.value)}
        placeholder={t('web.assignment.billing.form.observation.placeholder')}
        rows={5}
        value={value}
      />
    </Modal>
  )
}
